
import { useEffect, useRef, useMemo } from 'react';

export function useDebounce(callback, delay) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  return useMemo(() => {
    let timerId;

    return (...args) => {
      if (timerId) {
        clearTimeout(timerId);
      }

      timerId = setTimeout(() => {
        callbackRef.current(...args);
      }, delay);
    };
  }, [delay]);
}
